import styled from 'styled-components';

export const FormContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;

export const EligibilitySection = styled.div`
  margin-bottom: 32px;
  padding: 24px;
  background: ${props => props.theme.colors.background.secondary};
  border-radius: 8px;
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: ${props => props.theme.colors.content.primary};
`;

export const SectionDescription = styled.p`
  font-size: 14px;
  margin: 0 0 16px 0;
  color: ${props => props.theme.colors.content.secondary};
`;

export const ButtonContainer = styled.div`
  margin-top: 24px;
`;
